import { forwardRef, ComponentClass } from 'react';
import { ClassNamePropsWithChildren } from 'components/ozone-component';

export type TitleProps = ClassNamePropsWithChildren;

type TitleType = ComponentClass<TitleProps>;

// eslint-disable-next-line react/display-name
export const Title: TitleType = forwardRef((props: TitleProps, ref) => {
  const { children, className, ...rest } = props;

  return (
    <h5 ref={ref as any} className={className} {...rest}>
      {props.children}
    </h5>
  );
}) as unknown as TitleType;

Title.displayName = 'Title';
